import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Box, Typography, Hidden, Drawer, useMediaQuery } from '@mui/material';
import Images from '../../utils/Images';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../../utils/Api';
import gsap from 'gsap';
import { useDispatch, useSelector } from 'react-redux';
import { setData } from '../../store/Cart/cartSlice';
import { ArrowForward, ArrowForwardIos } from '@mui/icons-material';
import DeliveryScreen from './DeliveryScreen';
import DeliveryOutletScreen from './DeliveryScreens/DeliveryOutletScreen';
import PickupOutletScreen from './PickupScreens/PickupOutletScreen';

function AdvertiseScreen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userData, setUserData] = useState(null);
  const token = localStorage.getItem('token');
  const [clickableAdvertise, setClickableAdvertise] = useState([]);
  const [nonClickableAdvertise, setNonClickableAdvertise] = useState([]);
  const [outletData, setOutletData] = useState([]);
  let [isCartEmpty, setIsCartEmpty] = useState(true);
  const data = useSelector(state => state?.cart?.data);
  const [timeOfDay, setTimeOfDay] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [deliveryDrawerOpen, setDeliveryDrawerOpen] = useState(false);
  const matchesMdUp = useMediaQuery(theme => theme.breakpoints.up('md'));
  const [settings, setSettings] = useState('');
  const ordersType = localStorage.getItem("selectedOrderType");

  const animateBoxes = () => {
    gsap.fromTo('.deliveryContainer', { scale: 1 }, { scale: 1.1, duration: 0.5, yoyo: true, repeat: 1 });
    gsap.fromTo('.pickupContainer', { scale: 1 }, { scale: 1.1, duration: 0.5, yoyo: true, repeat: 1 });
  };

  const handleOptionSelect = (option) => {
    localStorage.setItem('selectedOrderType', option);
    // console.log(option);
    if (option === 'DELIVERY') {
      if (matchesMdUp) {
        setDeliveryDrawerOpen(true);
      } else {
        navigate('/deliveryScreen');
      }
    } else {
      if (matchesMdUp) {
        setDrawerOpen(true);
      } else {
        navigate('/pickupOutletSreen');
      }
    }
  };

  const getAdvertisments = async () => {
    try {
      // const response = await axios.get(`${API.BASE_URL}advertisement/getAdvertisements`);
      const response = await axios.get(`${API.BASE_URL}advertisement/user`);
      setNonClickableAdvertise(response?.data?.data?.advertisements?.nonClickableAdvertisements);
    } catch (error) {
      console.log("Error in getting Ads", error.response);
    }
  };

  const getSettings = async () => {
    try {
      const response = await axios.get(`${API.BASE_URL_2}settings/getStatus`);
      setSettings(response?.data?.data?.settings);
    } catch (error) {
      console.log("Error in getting Ads", error.response);
    }
  };

  const handleAdClick = () => {
    animateBoxes();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    const selectedStoreData = localStorage.getItem('selectedStoreData');
    if (!selectedStoreData && !open) {
      return;
    }
    setDrawerOpen(open);
  };

  const toggleDeliveryDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    const deliveryLatitude = localStorage.getItem("deliveryLatitude");
    const deliveryLongitude = localStorage.getItem("deliveryLongitude");
    const pickedAddress = localStorage.getItem("pickedAddress");
    const selectedStoreData = localStorage.getItem('selectedStoreData');
    if ((!deliveryLatitude || !deliveryLongitude || !pickedAddress || !selectedStoreData) && !open) {
      return;
    }
    setDeliveryDrawerOpen(open);
  };

  const [showScrollbar, setShowScrollbar] = useState(false);
  const advertiseScreenRef = useRef(null);

  const handleFocus = () => {
    setShowScrollbar(true);
  };

  const handleBlur = () => {
    setShowScrollbar(false);
  };

  const handleMouseEnter = () => {
    setShowScrollbar(true);
  };

  const handleMouseLeave = () => {
    setShowScrollbar(false);
  };

  const slides = useMemo(() => {
    const now = new Date();
    const all = Array.isArray(nonClickableAdvertise) ? nonClickableAdvertise : [];
    const validAds = all.filter(ad => {
      const start = ad?.validityStartDate ? new Date(ad.validityStartDate) : null;
      const end = ad?.validityEndDate ? new Date(ad.validityEndDate) : null;

      return (
        (!start || now >= start) &&
        (!end || now <= end)
      );
    });
    const top = validAds.filter(ad => ad?.isTopImage);

    return top.length ? top : validAds;
  }, [nonClickableAdvertise]);

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    setCurrentSlide(0);
    if (!slides || slides.length <= 1) return;
    const id = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(id);
  }, [slides]);

  useEffect(() => {
    window.scrollTo(0, 0);
    // const userDataLogin = JSON.parse(localStorage.getItem('userDataLogin'));
    setUserData(JSON.parse(localStorage.getItem('userDataLogin')));
    getAdvertisments();
    getSettings();
    setOutletData(JSON.parse(localStorage.getItem('selectedStoreData')));

    const currentTime = new Date().getHours();
    if (currentTime >= 5 && currentTime < 12) {
      setTimeOfDay('Morning');
    } else if (currentTime >= 12 && currentTime < 17) {
      setTimeOfDay('Afternoon');
    } else {
      setTimeOfDay('Evening');
    }
  }, []);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <>
      <Hidden mdUp>
        <Box className="advertiseScreen">
          <div className='homeMain'>
            <div className="slider-container">
              {nonClickableAdvertise?.length > 0 ? (
                nonClickableAdvertise
                  .filter(ad => ad?.isTopImage)
                  .map((ad, index) => {
                    return (
                      <div className="slide" key={index} style={{ transform: `translateX(${-currentSlide * 100}%)` }}>
                        <img src={ad?.adImagePath} alt={`Advertisement ${index}`} className="homeBannerImage" />
                      </div>
                    );
                  })
              ) : (
                <div className="slide">
                  <img src={Images.homeCover} alt="Fallback Image" className="homeBannerImage" />
                </div>
              )}
            </div>
            <Box className="homeContainer">
              {/* <Typography className="welcome">Welcome to Xpanse</Typography> */}
              <div className='homeContent'>
                <Box>
                  <Typography className='homeProfileName'>Hello, {userData?.name ? userData.name : 'User'}!</Typography>
                  <Typography className='homeDesc'>Good {timeOfDay}, let's find you<br /> the best cup of coffee!</Typography>
                </Box>
                <Box>
                  <img
                    src={userData?.profileImage ? userData?.profileImage : (userData?.gender === 'MALE' ? Images.maleAvatar : (userData?.gender === 'FEMALE' ? Images.femaleAvatar : Images.navProfile))}
                    // src={ userData?.profileImage || Images.profileHead } 
                    className='profileImg' alt=""
                  />
                </Box>
              </div>
              <div className='selectOptionSection'>
                <Typography sx={{ fontSize: '17px', color: '#0E4961', textAlign: 'center', padding: '0px 0 40px 0', fontWeight: '500' }}>Please Select</Typography>
                <Box className='deliveryContainer' sx={{ backgroundColor: '#DFEEF4' }}
                  onClick={() => { if (settings?.selfPickup !== 'INACTIVE') { handleOptionSelect('PICKUP'); navigate('/pickupOutletScreen'); } }}
                // onClick={() => handleOptionSelect('PICKUP'), navigate('/pickupOutletScreen')}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box>
                      <Typography className="deliveryText" sx={{ textAlign: 'left' }}>Self Pick-Up</Typography>
                      {settings?.selfPickup === 'INACTIVE' ? (
                        <Typography sx={{ fontSize: '14px', marginLeft: '-8px' }}>Temporarily Unavailable</Typography>
                      ) : (
                        null
                      )}
                    </Box>
                    {settings?.selfPickup === 'INACTIVE' ? (
                      null
                    ) : (
                      <ArrowForwardIos sx={{ color: '#0E4961' }} />
                    )}
                  </Box>
                  <img className="pickupBox" style={{ objectFit: 'cover' }} src={Images.pickupOption} />
                </Box>

                <Box className='deliveryContainer' onClick={() => { if (settings?.delivery !== 'INACTIVE') { handleOptionSelect('DELIVERY'); navigate('/deliveryScreen'); } }} sx={{ backgroundColor: settings?.delivery === 'INACTIVE' ? '#cecece' : '#DFEEF4' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box>
                      <Typography className="deliveryText" sx={{ textAlign: 'left' }}>Delivery</Typography>
                      {settings?.delivery === 'INACTIVE' ? (
                        <Typography sx={{ fontSize: '14px', marginLeft: '-8px' }}>Coming soon...</Typography>
                      ) : (
                        null
                      )}
                    </Box>
                    {settings?.delivery === 'INACTIVE' ? (
                      null
                    ) : (
                      <ArrowForwardIos sx={{ color: '#0E4961' }} />
                    )}
                  </Box>
                  <img className="deliveryBox" src={Images.deliveryOption} />
                </Box>
              </div>
              {nonClickableAdvertise?.filter(ad => ad?.isBottomImage).length > 0 ? (
                nonClickableAdvertise.filter(ad => ad?.isBottomImage).map((ad, index) => (
                  <div className='adImageBox' key={index}>
                    <img onClick={handleAdClick} loading='lazy' className="adImage" src={ad?.adImagePath || Images.adBanner} alt={`Advertisement ${index}`} />
                  </div>
                ))
              ) : (
                <div className='adImageBox'>
                  <img loading='lazy' className="adImage" src={Images.adBanner} alt="Fallback Advertisement" />
                </div>
              )}
            </Box>
          </div>
        </Box>
      </Hidden>
      <Hidden mdDown>
        <Box ref={advertiseScreenRef}
          className={`advertiseScreen ${showScrollbar ? "show-scrollbar" : ""}`}
          tabIndex="0"
          onFocus={handleFocus}
          onBlur={handleBlur}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className='homeMain'>
            <div className="slider-container">
              {nonClickableAdvertise?.length > 0 ? (
                nonClickableAdvertise
                  .filter(ad => ad?.isTopImage)
                  .map((ad, index) => {
                    return (
                      <div className="slide" key={index} style={{ transform: `translateX(${-currentSlide * 100}%)` }}>
                        <img src={ad?.adImagePath} alt={`Advertisement ${index}`} className="homeBannerImage" />
                      </div>
                    );
                  })
              ) : (
                <div className="slide">
                  <img src={Images.homeCover} alt="Fallback Image" className="homeBannerImage" />
                </div>
              )}
            </div>
            <Typography className="welcome">Welcome to Xpanse</Typography>
            <Box className='homeContent' sx={{ padding: '0 40px 10px 40px' }}>
              <Box>
                <Typography className='homeProfileName'>Hello, {userData?.name ? userData.name : 'User'}!</Typography>
                <Typography className='homeDesc'>Good {timeOfDay}, let's find you<br /> the best cup of coffee!</Typography>
              </Box>
              <Box>
                <img src={userData?.profileImage || Images.profileHead} className='profileImg' alt="" />
              </Box>
            </Box>
            <Box className="homeContainer">
              <div className='selectOptionSection'>
                <Typography sx={{ fontSize: '17px', color: '#186B8C', textAlign: 'center' }}>Please Select</Typography>
                <Box className='deliveryContainer' onClick={() => settings?.selfPickup === 'INACTIVE' ? null : handleOptionSelect('PICKUP')} sx={{ backgroundColor: settings?.selfPickup === 'INACTIVE' ? '#cecece' : '#DFEEF4', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box>
                      <Typography className="deliveryText" sx={{ textAlign: 'left' }}>Self Pick-Up</Typography>
                      {settings?.selfPickup === 'INACTIVE' ? (
                        <Typography sx={{ fontSize: '14px', marginLeft: '-8px' }}>Temporarily Unavailable</Typography>
                      ) : (
                        null
                      )}
                    </Box>
                    {settings?.selfPickup === 'INACTIVE' ? (
                      null
                    ) : (
                      <ArrowForwardIos sx={{ color: '#0E4961' }} />
                    )}
                  </Box>
                  <img style={{ filter: 'none' }} className="deliveryBox" src={Images.pickupOption} alt='pickup' loading='lazy' />
                </Box>
                <Box className='deliveryContainer' onClick={() => settings?.delivery === 'INACTIVE' ? null : handleOptionSelect('DELIVERY')} sx={{ backgroundColor: settings?.delivery === 'INACTIVE' ? '#cecece' : '#DFEEF4', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box>
                      <Typography className="deliveryText" sx={{ textAlign: 'left' }}>Delivery</Typography>
                      {settings?.delivery === 'INACTIVE' ? (
                        <Typography sx={{ fontSize: '14px', marginLeft: '-8px' }}>Coming soon...</Typography>
                      ) : (
                        null
                      )}
                    </Box>
                    {settings?.delivery === 'INACTIVE' ? (
                      null
                    ) : (
                      <ArrowForwardIos sx={{ color: '#0E4961' }} />
                    )}
                  </Box>
                  <img className="deliveryBox" src={Images.deliveryOption} alt='delivery' loading='lazy' />
                </Box>
              </div>
            </Box>
          </div>
        </Box>
      </Hidden>
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{ className: "your-drawer-class" }}
      >
        <Box sx={{ overflow: 'auto' }} className="hide-scrollbar">
          <PickupOutletScreen />
        </Box>
      </Drawer>
      <Drawer
        anchor="left"
        open={deliveryDrawerOpen}
        onClose={toggleDeliveryDrawer(false)}
        PaperProps={{
          sx: {
            height: '100%',
            overflow: 'auto',
            backgroundColor: '#DFEEF4',
            '&::-webkit-scrollbar': {
              display: 'none'
            },
          }
        }}
      >
        <Box>
          <DeliveryScreen />
        </Box>
      </Drawer>
    </>
  )
}

export default AdvertiseScreen;

// import React, { useEffect, useState } from 'react';
// import { Box, Grid, Drawer, IconButton, Typography, CircularProgress, Stack, Divider } from '@mui/material';
// import { ChildFriendlySharp, CloseOutlined, StarRounded } from '@mui/icons-material';
// import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
// import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
// import AddCircleIcon from '@mui/icons-material/AddCircle';
// import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
// // import AddonIconComponent from '../../components/AddonIconComponent';
// import AddonIconComponent from './AddonIconComponent';
// import Images from '../utils/Images';
// import toast from 'react-hot-toast';

// const ProductDrawer = ({open,onClose,selectedProduct,handleAddToCart,quantity,handleIncreaseQuantity,handleDecreaseQuantity,selectedAddons,handleAddonSelect,totalPrice,totalMrpPrice,offerPercentage, addingToCart }) => {
//   const [outletData, setOutletData] = useState(JSON.parse(localStorage.getItem('selectedStoreData')));
//   const [isMultiple, setIsMultiple] = useState(true);

//   useEffect(() => {
//     if (!selectedProduct?.addons) return;

//     selectedProduct?.addons?.forEach(addon => {
//       // skip addons with no defaults
//       const defaults = addon?.values
//         .filter(v => v?.isDefault
//           && v?.status !== 'INACTIVE'
//           && !v?.excludedOutlets?.includes(outletData?._id));

//       if (defaults?.length) {
//         if (addon?.isMultipleSelect) {
//           // multiple defaults → pass an array
//           handleAddonSelect(
//             addon._id,
//             defaults.map(v => ({
//               ...v,
//               offerPrice: v?.price ?? 0,
//               mrp: v?.price ?? 0,
//             })),
//             true
//           );
//         } else {
//           const v = defaults[0];
//           handleAddonSelect(
//             addon._id,
//             { ...v, offerPrice: v?.price ?? 0, mrp: v?.price ?? 0 },
//             false
//           );
//         }
//       }
//     });
//   }, [selectedProduct, outletData]);

//   const validateAddonsBeforeAddToCart = () => {
//     const invalidAddonTitles = [];

//     selectedProduct?.addons?.forEach((addon) => {
//       const hasDefaultExcluded = addon?.values?.some(
//         (val) => val?.isDefault && val?.excludedOutlets?.includes(outletData?._id)
//       );

//       const hasDefaultInactive = addon?.values?.some(
//         (val) => val?.isDefault && val?.status === 'INACTIVE'
//       );

//       const selected = selectedAddons[addon?._id];

//       let isInvalid = false;

//       if (addon?.isMultipleSelect) {
//         isInvalid =
//           (hasDefaultExcluded || hasDefaultInactive) &&
//           (!Array.isArray(selected) || selected.length === 0);
//       } else {
//         isInvalid =
//           (hasDefaultExcluded || hasDefaultInactive) &&
//           (!selected ||
//             selected?.excludedOutlets?.includes(outletData?._id) ||
//             selected?.status === 'INACTIVE');
//       }

//       if (isInvalid) {
//         invalidAddonTitles.push(addon?.title);
//       }
//     });

//     if (invalidAddonTitles?.length > 0) {
//       toast.error(
//         `Please select other available options for: ${invalidAddonTitles?.join(', ')}`
//       );
//       return false;
//     }

//     return true;
//   };
  
//   return (
//     <Drawer open={open} onClose={onClose} anchor="bottom">
//       <Box className="productDrawer">
//         <IconButton
//           onClick={onClose}
//           sx={{ position: 'absolute', top: -20, right: 8, zIndex: 1, backgroundColor: '#fff', height: '16px', width: '16px' }}
//         >
//           <CloseOutlined sx={{ fontSize: '12px' }} />
//         </IconButton>
//         <Grid container>
//           <Grid item xs={5} sx={{ justifyContent: 'center' }}>
//             <Box className="imageBox">
//               <img className="image" src={selectedProduct?.displayImageUrl || selectedProduct?.displayImage} alt="Product" />
//             </Box>
//           </Grid>
//           <Grid item xs={7} sx={{ paddingLeft: '2%' }}>
//             <Box className="productDetails">
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <Typography className="productName" sx={{ textAlign: 'left' }}>{selectedProduct?.name}</Typography>
//               </Box>
//               <Typography className="productInfo">{selectedProduct?.description}</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <>
//                     {selectedProduct?.foodType === 'VEG/VEGAN' ? (
//                       <Stack direction={'row'}>
//                         <img className='vegNonveg' src={Images.veg} alt='veg' />
//                         <img style={{ height: '20px', marginRight: '4px' }} className='vegNonveg' src={Images.vegan} alt='vegan' />
//                       </Stack>
//                     ) : (
//                       <>
//                         {selectedProduct && (
//                           <img style={{ height: '20px' }} className='vegNonveg' src={selectedProduct.foodType === 'VEG' ? Images.veg : (selectedProduct.foodType === 'VEGAN' ? Images.vegan : Images.nonVeg)} alt={selectedProduct.foodType === 'VEG' ? 'veg' : (selectedProduct.foodType === 'VEGAN' ? 'vegan' : 'non-veg')} />
//                         )}
//                       </>
//                     )}
//                   </>
//                   <Typography sx={{ color: '#6B6C6E', paddingLeft: '7px' }}>{selectedProduct?.calories} Kcal</Typography>
//                 </Box>
//                 <Box sx={{ width: '1.5px', height: '20px', backgroundColor: '#6B6C6E', marginX: '8px' }} />
//                 <Typography sx={{ color: '#6B6C6E' }}>{selectedProduct?.weight} {selectedProduct?.weightUnit}</Typography>
//               </Box>
//             </Box>
//           </Grid>
//         </Grid>
//         {selectedProduct && (
//           <>
//             {selectedProduct?.hasAddon && selectedProduct?.addons && selectedProduct?.addons?.length > 0 && (
//               <Box className="addonsBox">
//                 {selectedProduct?.addons
//                   .filter((addon) => !addon?.excludedOutlets?.includes(outletData?._id))
//                   .map((addon) =>
//                     addon?.values?.some((val) => val?.status !== 'INACTIVE' && !val?.excludedOutlets?.includes(outletData?._id)
//                     ) && (
//                       <Grid container key={addon._id} sx={{ padding: '10px 10px 7px 10px', backgroundColor: '#fff', marginBottom: '10px', borderRadius: '18px' }}>
//                         <Grid item xs={3} sx={{ display: 'flex', paddingTop: '10px', alignItems: addon?.badgeImage ? 'center' : 'normal' }}>
//                           {addon?.badgeImage &&
//                             <img style={{ width: '40%', paddingRight: '10px' }} src={addon?.badgeImage} />
//                           }
//                           <Typography className="addonTitle">{addon?.title}</Typography>
//                         </Grid>
//                         <Grid item xs={9}>
//                           {addon?.values?.some(v => v?.selectedImage || v?.nonSelectedImage) ? (
//                             <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                               <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
//                                 {addon?.values
//                                   // .filter((addon) => addon?.status !== 'INACTIVE' && !addon?.iconInfo)
//                                   // .filter((addon) => !addon?.excludedOutlets?.includes(outletData?._id))
//                                   // .filter((addon) => (!addon?.iconInfo) && (addon?.status !== 'INACTIVE' || addon?.isDefault))
//                                   // .filter((addon) => !addon?.excludedOutlets?.includes(outletData?._id) || addon?.isDefault)
//                                   .filter((addon) =>
//                                     (!addon?.iconInfo) &&
//                                     (addon?.status !== 'INACTIVE' || addon?.isDefault) &&
//                                     (!addon?.excludedOutlets?.includes(outletData?._id) || addon?.isDefault)
//                                   )
//                                   .map((addonValue) => {
//                                     const isSelected = addon?.isMultipleSelect ? Array.isArray(selectedAddons[addon?._id]) && selectedAddons[addon?._id].some((selected) => selected?._id === addonValue?._id) : selectedAddons[addon?._id]?._id === addonValue?._id;
//                                     const isDefault = addonValue?.isDefault;

//                                     const isExcluded = addonValue?.excludedOutlets?.includes(outletData?._id);
//                                     const isDisabled = isExcluded;

//                                     const hasExplicitSelection = addon?.isMultipleSelect
//                                       ? Array.isArray(selectedAddons[addon?._id]) &&
//                                       selectedAddons[addon?._id].length > 0
//                                       : !!selectedAddons[addon?._id];

//                                     const showSelectedImage = isSelected || (!hasExplicitSelection && addonValue?.isDefault);

//                                     return (
//                                       <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
//                                         <img
//                                           key={addonValue?._id}
//                                           onClick={() =>
//                                             handleAddonSelect(
//                                               addon._id,
//                                               {
//                                                 ...addonValue,
//                                                 offerPrice: addonValue?.price ?? 0,
//                                                 mrp: addonValue?.price ?? 0,
//                                               },
//                                               addon?.isMultipleSelect
//                                             )
//                                           }
//                                           src={showSelectedImage ? addonValue?.selectedImage : addonValue?.nonSelectedImage}
//                                           alt={addonValue?.value}
//                                           style={{
//                                             cursor: isDisabled ? 'not-allowed' : 'pointer',
//                                             filter: isDisabled ? 'grayscale(100%) opacity(0.6)' : 'none',
//                                           }}
//                                         />
//                                         <Typography className="addonValue" sx={{ color: '#00A4E2' }}>
//                                           {addonValue?.subLabel}
//                                         </Typography>
//                                         <Box>
//                                           <Typography color={'green'} variant='caption'>+₹{addonValue?.price ?? 0}</Typography>
//                                         </Box>
//                                       </Box>
//                                     );
//                                   })}
//                               </Box>
//                             </Box>
//                           ) : (
//                             <Stack spacing={1}>
//                               {addon?.values
//                                 .filter((addon) =>
//                                   (!addon?.iconInfo) &&
//                                   (addon?.status !== 'INACTIVE' || addon?.isDefault) &&
//                                   (!addon?.excludedOutlets?.includes(outletData?._id) || addon?.isDefault)
//                                 )
//                                 // .filter((addon) => addon?.status !== 'INACTIVE' && !addon?.iconInfo)
//                                 // .filter((addon) => !addon?.excludedOutlets?.includes(outletData?._id))
//                                 // .filter((addon) =>
//                                 //   addon?.status !== 'INACTIVE' &&
//                                 //   !addon?.iconInfo &&
//                                 //   (!addon?.excludedOutlets?.includes(outletData?._id) || addon?.isDefault)
//                                 // )
//                                 .map((addonValue) => {

//                                   const isSelected = addon?.isMultipleSelect
//                                     ? Array.isArray(selectedAddons[addon?._id]) &&
//                                     selectedAddons[addon?._id].some(s => s._id === addonValue?._id)
//                                     : selectedAddons[addon?._id]?._id === addonValue?._id;

//                                   const hasExplicitSelection = addon?.isMultipleSelect
//                                     ? Array.isArray(selectedAddons[addon._id]) &&
//                                     selectedAddons[addon?._id].length > 0
//                                     : Boolean(selectedAddons[addon?._id]);

//                                   const isDefault = addonValue?.isDefault;
//                                   // exactly the same default‐logic as your image layout:
//                                   const showSelected = isSelected || (!hasExplicitSelection && isDefault);

//                                   // const isExcluded = addonValue?.excludedOutlets?.includes(outletData?._id);
//                                   // const isDisabled = isExcluded;

//                                   const isExcluded = addonValue?.excludedOutlets?.includes(outletData?._id);
//                                   const isInactiveDefault = addonValue?.isDefault && addonValue?.status === 'INACTIVE';
//                                   const isDisabled = isExcluded || isInactiveDefault;

//                                   return (
//                                     <Box
//                                       key={addonValue?._id}
//                                       className="addonItem"
//                                       onClick={() => {
//                                         // if (isDisabled) return;
//                                         if (isDisabled) {
//                                           if (isInactiveDefault) {
//                                             toast.error('This default addon is currently unavailable.');
//                                           } else if (isExcluded) {
//                                             toast.error('This addon is not available at this outlet.');
//                                           }
//                                           return;
//                                         }
//                                         handleAddonSelect(addon?._id, {
//                                           ...addonValue,
//                                           offerPrice: addonValue?.price ?? 0,
//                                           mrp: addonValue?.price ?? 0,
//                                         }, addon?.isMultipleSelect)
//                                       }}
//                                       sx={{
//                                         display: 'flex',
//                                         flexDirection: 'column',
//                                         alignItems: 'flex-end',
//                                         padding: '4px 0',
//                                         cursor: isDisabled ? 'not-allowed' : 'pointer',
//                                         opacity: isDisabled ? 0.6 : 1,
//                                         filter: isDisabled ? 'grayscale(100%) opacity(0.6)' : 'none'
//                                       }}
//                                     >
//                                       <Typography className="addonValue" sx={{ color: '#00A4E2', cursor: isDisabled ? 'not-allowed' : 'pointer' }}>
//                                         {addonValue?.subLabel}
//                                       </Typography>
//                                       <Box className={`addonSelect ${(isSelected || showSelected) ? 'selected' : 'unselected'}`}>
//                                         {addonValue?.value ?? 0} <span style={{ paddingLeft: '7px' }}>+₹{addonValue?.price ?? 0}</span>
//                                       </Box>
//                                     </Box>
//                                   );
//                                 })}
//                             </Stack>
//                           )}
//                         </Grid>
//                       </Grid>
//                     )
//                   )}
//               </Box>
//             )}
//           </>
//         )}
//         <Box className="priceAndButton">
//           <Box className="addRemoveItem">
//             <RemoveCircleIcon className="text" onClick={handleDecreaseQuantity} />
//             <Typography sx={{ color: '#000' }} className="text">{quantity}</Typography>
//             <AddCircleIcon className="text" onClick={handleIncreaseQuantity} />
//           </Box>
//           <>
//             {outletData?.isEventOutlet === selectedProduct?.isEventProduct ? (
//               addingToCart ? (
//                 <Box className="d-button">
//                   <CircularProgress size={18} sx={{ color: '#fff' }} /> Adding to cart
//                 </Box>
//               ) : (
//                 // <Box className={selectedProduct?.isExhausted ? "exhaustedButton" : "d-button"} onClick={!selectedProduct?.isExhausted ? handleAddToCart : null}>
//                 <Box className={selectedProduct?.isExhausted ? "exhaustedButton" : "d-button"}
//                   onClick={() => {
//                     if (selectedProduct?.isExhausted) return;

//                     if (!validateAddonsBeforeAddToCart()) {
//                       // toast.error('Please select available addon options for all required addon groups.');
//                       return;
//                     }

//                     handleAddToCart();
//                   }}
//                 >
//                   {selectedProduct?.isExhausted ? (
//                     "Out Of Stock"
//                   ) : (
//                     <>
//                       <span>Add</span>
//                       <span className="divider" />
//                       <span>₹{(parseFloat(totalPrice) * parseInt(quantity)).toFixed(2)}</span>
//                     </>
//                   )}
//                 </Box>
//               )
//             ) : (
//               <Box className="exhaustedButton" sx={{ flex: '0 0 auto', marginLeft: '20px' }}>
//                 <span style={{ fontSize: '16px' }}>Order this at our store</span>
//               </Box>
//             )}
//           </>
//         </Box>
//       </Box>
//     </Drawer>
//   );
// };

// export default ProductDrawer;
